import { fetchProcessingFee } from "@/helpers/pricing/fetchPricingData";
import type { ShipProcessingFee } from "@/schemas/ship";

export const getSortedProcessingFeesByChannel = async () => {
  const processingFees = await fetchProcessingFee();

  const airFees = processingFees
    .filter((fee) => fee.channel === "Air")
    .sort((a, b) => a.start_range - b.start_range);
  const seaFees = processingFees
    .filter((fee) => fee.channel === "Sea")
    .sort((a, b) => a.start_range - b.start_range);

  return { airFees, seaFees };
};

export const formatNumber = (value: number) =>
  new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(value);

export const getUnitLabel = (unit: ShipProcessingFee["unit"]) =>
  unit === "kg" ? "kg" : unit.toUpperCase();

export const formatRange = (fee: ShipProcessingFee) => {
  const unitLabel = getUnitLabel(fee.unit);
  const startValue = formatNumber(fee.start_range);
  const endValue = formatNumber(fee.end_range);

  if (fee.end_range <= fee.start_range || fee.end_range === 0) {
    return `Over ${startValue}${unitLabel}`;
  }

  return `${startValue}${unitLabel} - ${endValue}${unitLabel}`;
};

export const formatRate = (fee: ShipProcessingFee) => {
  const currencySymbol = fee.currency === "USD" ? "$" : fee.currency;
  const unitLabel = getUnitLabel(fee.unit);
  return `${currencySymbol}${formatNumber(fee.value)}/${unitLabel}`;
};
